<template>
  <v-container id="reportList" >
    <header
      style="display:flex; flex-direction:column; align-items:center; justify-content:center;"
    >
      <div style="border-bottom:1px solid #aaa; width:100%; text-align:center;margin-bottom:10px">
        <h2 style="font-weight: 400">{{$store.getters.getAppName}}</h2>
      </div>
      <img
        :src="prefecture.prefecture_logo ? $store.state.urlImages + prefecture.prefecture_logo : require('@/assets/no-image.jpg')"
        :alt="prefecture.social_name ? prefecture.social_name : ''"
        style="width:30%;padding:1%"
      />
      <h1
        style="font-weight: 400;"
      >{{prefecture.prefecture_social_name ? prefecture.prefecture_social_name : ''}}</h1>
      <h3
        style="font-weight: 400;margin-bottom:10px"
      >Fornecedor: {{provider && provider.provider_name ? provider.provider_name : ''}}</h3>
      <h4>Período de: {{convertDate(filter.startDate)}} até {{convertDate(filter.endDate)}}</h4>
    </header>

    <table
      style="border-collapse: collapse;border: 1px solid rgb(214, 214, 214);padding:20px;margin-top:20px;"
      v-for="(d,i) in data.secs"
      :key="i"
    >
      <tbody>
        <tr style="background:gray;">
          <td style="padding:5px;font-weight:bold;color:#fff;">SETOR</td>
        </tr>
        <tr>
          <td style="padding:5px">{{d.sec_name}}</td>
        </tr>
        <tr>
          <td>
            <table
              class="table"
              style="border-collapse: collapse;border: 1px solid rgb(214, 214, 214);"
            >
              <thead>
                <tr style="border: 1px solid rgb(214, 214, 214);text-align:center">
                  <th
                    style="width:15%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:gray;color:#fff"
                  >SUBSETOR</th>
                  <th
                    style="width:15%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:gray;color:#fff"
                  >VEICULO</th>
                  <th
                    style="width:15%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:gray;color:#fff"
                  >MODELO</th>
                  <th
                    style="width:15%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:gray;color:#fff"
                  >PLACA</th>
                  <th
                    style="width:40%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:gray;color:#fff"
                  >ABASTECIMENTOS</th>
                </tr>
              </thead>
              <tbody v-for="(vehicle,ix) in d.vehicles" :key="ix">
                <tr>
                  <td
                    style="width:15%;border: 1px solid rgb(214, 214, 214);padding:8px; text-align:center; font-weight:bold"
                  >{{vehicle.subsec_desc ? vehicle.subsec_desc : '---'}}</td>
                  <td
                    style="width:15%;border: 1px solid rgb(214, 214, 214);padding:8px; text-align:center;font-weight:bold"
                  >{{vehicle.brand_desc}}</td>
                  <td
                    style="width:15%;border: 1px solid rgb(214, 214, 214);padding:8px; text-align:center;font-weight:bold"
                  >{{vehicle.model_desc}}</td>
                  <td
                    style="width:15%;border: 1px solid rgb(214, 214, 214);padding:8px; text-align:center;font-weight:bold"
                  >{{vehicle.vehicle_board}}</td>
                  <td style="padding:30px; border-bottom:1px solid rgb(214, 214, 214)">
                    <table class="table" >
                      <thead>
                        <tr>
                          <th
                            style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                          >POSTO</th>
                          <th
                            style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                          >COMBUSTÍVEL</th>
                          <th
                            style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                          >DATA</th>
                          <th
                            style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                          >LITROS ABASTECIDOS</th>
                          <th
                            style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                          >PREÇO LICITADO (aditivado)</th>
                          <th
                            style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                          >VALOR TOTAL LICITADO</th>
                          <th
                            style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                          >PREÇO DIA</th>
                          <th
                            style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                          >VALOR TOTAL DIA</th>
                          <th
                            style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                          >CUPOM</th>
                          <th
                            style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                          >FATURADO</th>
                        </tr>
                      </thead>
                      <tbody v-for="(supply,sx) in vehicle.supplies" :key="sx">
                        <tr
                          style="border:1px solid rgb(214, 214, 214);border-bottom: 1px solid rgb(214, 214, 214);"
                        >
                          <td
                            style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                          >{{supply.provider_name}}</td>
                          <td
                            style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                          >{{supply.item_description_desc}}</td>
                          <td
                            style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                          >{{convertDateTime(supply.datehour)}}</td>
                          <td
                            style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                          >{{supply.supply_liters_stocked ? realMaskII(supply.supply_liters_stocked.toFixed(3)) : 0}}</td>
                          <td
                            style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                          >{{supply.supply_bidding_price ? realMaskII(supply.supply_bidding_price.toFixed(3)) : 0}}</td>
                          <td
                            style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                          >{{realMask((supply.supply_bidding_value).toFixed(2)) }}</td>
                          <td
                            style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                          >{{supply.supply_price_day ? realMaskII((supply.supply_price_day).toFixed(3)) : 0}}</td>
                          <td
                            style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                          >{{supply.supply_value ? realMask((supply.supply_value).toFixed(2)) : 0}}</td>
                          <td
                            style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                          >{{supply.supply_coupon}}</td>
                          <td
                            style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                          >{{supply.supply_billed ? 'SIM' : 'ABERTO'}}</td>
                        </tr>
                      </tbody>
                      <tr>
                        <th
                          style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                        >TOTAIS</th>
                        <th
                          style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                        ></th>
                        <th
                          style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                        ></th>
                        <th
                          style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                        >Lts: {{vehicle.totals.total_liters ? realMaskII(vehicle.totals.total_liters.toFixed(3)) : 0}}</th>
                        <th
                          style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                        ></th>
                        <th
                          style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                        >R$: {{vehicle.totals.billing_value ? realMask(vehicle.totals.billing_value.toFixed(2)) : 0}}</th>
                        <th
                          style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                        ></th>
                        <th
                          style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                        >R$: {{vehicle.totals.total_value ? realMask(vehicle.totals.total_value.toFixed(2)) : 0}}</th>
                        <th
                          style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                        ></th>
                        <th
                          style="border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;color:#000;font-weight:500"
                        ></th>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="width:100%;">
      <h2 style="width:100%;text-align:center;margin:30px 0">RESUMOS</h2>
      <div style="display:flex; justify-content:space-between;">
        <table
          class="table"
          style="border-collapse: collapse;border: 1px solid rgb(214, 214, 214);width:48%"
        >
          <thead>
            <tr style="border: 1px solid rgb(214, 214, 214);text-align:center">
              <th
                style="width:15%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:gray;color:#fff"
              >RESUMO PREÇO LICITADO</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <table
                  class="table"
                  style="border-collapse: collapse;border: 1px solid rgb(214, 214, 214);width:100%"
                >
                  <thead>
                    <tr style="width:100%;border: 1px solid rgb(214, 214, 214);text-align:center">
                      <th
                        style="width:25%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;"
                      >Tipo</th>
                      <th
                        style="width:25%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;"
                      >Preço Licitado</th>
                      <th
                        style="width:25%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;"
                      >Total Litros</th>
                      <th
                        style="width:25%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;"
                      >Valor Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(resume,resumeIndex) in data.resume" :key="resumeIndex">
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{resume.item_description_desc}}</td>
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{resume.supply_bidding_price ? realMaskII(resume.supply_bidding_price.toFixed(3)):0}}</td>
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{resume.litersStocked ? realMask(resume.litersStocked.toFixed(2)) : 0}}</td>
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{resume.totalBillingPrice ? realMask(resume.totalBillingPrice.toFixed(2)):0}}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <b>TOTAL:</b>
                      </td>
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{data.resumeTotals.totalLiters ? realMask(data.resumeTotals.totalLiters.toFixed(2)): 0}}</td>
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{data.resumeTotals.totalBidding ? realMask(data.resumeTotals.totalBidding.toFixed(2)) : 0}}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          class="table"
          style="border-collapse: collapse;border: 1px solid rgb(214, 214, 214);width:48%"
        >
          <thead>
            <tr style="border: 1px solid rgb(214, 214, 214);text-align:center">
              <th
                style="width:15%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:gray;color:#fff"
              >RESUMO PREÇO DIA</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <table
                  class="table"
                  style="border-collapse: collapse;border: 1px solid rgb(214, 214, 214);width:100%"
                >
                  <thead>
                    <tr style="width:100%;border: 1px solid rgb(214, 214, 214);text-align:center">
                      <th
                        style="width:25%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;"
                      >Tipo</th>
                      <th
                        style="width:25%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;"
                      >Preço Dia</th>
                      <th
                        style="width:25%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;"
                      >Total Litros</th>
                      <th
                        style="width:25%;border: 1px solid rgb(214, 214, 214);padding:5px; text-align:center;background:#ddd;"
                      >Valor Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(resume,resumeIndex) in data.resume" :key="resumeIndex">
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{resume.item_description_desc}}</td>
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{resume.supply_price_day ? realMaskII(resume.supply_price_day.toFixed(3)) : 0}}</td>
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{resume.litersStocked ? realMask(resume.litersStocked.toFixed(2)) : 0}}</td>
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{resume.totalPriceDay ? realMask(resume.totalPriceDay.toFixed(2)) : 0}}</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <b>TOTAL:</b>
                      </td>
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{data.resumeTotals.totalLiters ? realMask(data.resumeTotals.totalLiters.toFixed(2)) : 0}}</td>
                      <td
                        style="border:1px solid rgb(214, 214, 214);text-align:center; padding:5px"
                      >{{data.resumeTotals.totalDay ? realMask(data.resumeTotals.totalDay.toFixed(2)) :0}}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import helpers from "../../../mixins/helpers";
export default {
  props: ["data","filter", "prefecture", "provider"],
  mixins: [helpers],
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgb(17, 17, 17);
}
</style>